export default function () {
	this.parentFragment.bubble();
}
